import React, { Component } from "react";
import { View, Image, Text } from 'react-native'
import { SoundManager } from "../../../../assets/soundManager2";
import { connect } from "react-redux";

import { ButtonTitleDark, ButtonTitleLight } from "../../../../components/TextStyles";
import styles from "../../../../styles";
import { Touchable } from "../../../../components";
import { colors, global } from "../../../../const";
import { getDailyRiddleQuestion } from "../../../../action";
import { play_white, play_dark, pause_white, pause_dark } from "../../../../assets";
import localize from "../../../../localize";
const soundManager = new SoundManager();

class AudioMessage extends Component {

    SoundObject = soundManager.createSound();

    constructor(props) {
        super(props)
        let message = props.url.split('^');
        this.state = {
            url: message[1],
            progress: 0,
            duration: message[0],
            soundId: props.id,
            error: "",
            isAnswered: false,
        }
    }

    async componentDidMount() {
        let { daily_riddle, kind, type } = this.props;
        if (!daily_riddle) daily_riddle = await this.props.getDailyRiddleQuestion();
        if (type === 0 && kind === 1 && daily_riddle.status !== 200 && this.props.time > this.props.daily_riddle.time_today) return this.setState({ isAnswered: true });
    }
    onSoundToggle = async () => {
        try {

            let { daily_riddle, kind, type } = this.props;
            if (!daily_riddle) daily_riddle = await this.props.getDailyRiddleQuestion();
            if (type === 0 && kind === 1 && daily_riddle.status === 200 && this.props.time > this.props.daily_riddle.time_today) return this.setState({ error: localize.answer_your_riddle_question });

            if (this.SoundObject.playState === 1) return this.SoundObject.stop()
            this.SoundObject = soundManager.createSound({
                id: `sound_${this.state.soundId}`,
                url: this.state.url,
                useHTML5Audio: true,
                pan: -75,
                whileplaying: () => {
                    this.setState({ progress: ((this.SoundObject.position / 1000.0) | 0), duration: ((this.SoundObject.duration / 1000.0) | 0) })
                },
                onfinish: () => {
                    this.setState({ progress: 0, isPlaying: false })
                },
                onstop: () => {
                    this.setState({ progress: 0, isPlaying: false })
                },
                onerror: () => {
                    this.SoundObject.stop()
                    this.setState({ error: localize.playback_failed })
                }

            });
            soundManager.stopAll();
            this.SoundObject.play()

        } catch (error) {
            console.log("SoundManager :- ", error);
            this.SoundObject.stop()
            this.setState({ error: "playback failed!" })
        }
    }


    render() {
        const { type, ans, kind, daily_riddle, time } = this.props;
        const { duration, progress, error } = this.state
        if (type === 1)
            return (
                <>
                    {
                        kind === 1 && (
                            <View style={[styles.msgContainerSend, { flexDirection: "row", alignItems: "center", backgroundColor: colors.ultralight, borderTopRightRadius: 20, maxWidth: 200, marginVertical: 5 }]}>
                                <Text style={{ fontFamily: global.FONT_REGULAR, fontSize: 15, color: colors.midnightBack }}>
                                    (the answer to the Riddle is: "{ans}")
                                </Text>
                            </View>
                        )

                    }

                    <View>
                        <View style={[styles.msgContainerSend, styles.bgBlue, { borderTopRightRadius: this.props.redius === null ? 20 : 3 }]}>
                            <View style={{ flexDirection: "row", alignItems: "center" }}>

                                <Touchable
                                    style={{ padding: 8 }}
                                    component={(<Image source={this.SoundObject.playState !== 1 ? play_white : pause_white} style={{ width: 18, height: 18 }} resizeMode="contain" />)}
                                    onPress={this.onSoundToggle}
                                />

                                <ButtonTitleLight title={this.SoundObject.playState === 1 ? (progress | 0) : (duration | 0)} />

                            </View>
                        </View>
                        <Text style={{ color: colors.alert, fontSize: 10, textAlign: 'right', fontFamily: global.FONT_REGULAR, fontWeight: 'bold' }}>{error}</Text>
                    </View>
                </>
            )
        return (

            <View style={{ flexDirection: 'row' }}>

                <View style={[styles.msgContainerReceive, styles.bgUltralight]}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>

                        <Touchable
                            style={{ padding: 8 }}
                            component={(<Image source={this.SoundObject.playState !== 1 ? play_dark : pause_dark} style={{ width: 18, height: 18 }} resizeMode="contain" />)}
                            onPress={this.onSoundToggle}
                        />

                        <ButtonTitleDark title={this.SoundObject.playState === 1 ? (progress | 0) : (duration | 0)} />

                    </View>
                </View>

                {this.state.isAnswered &&
                    (
                        <View style={[styles.msgContainerSend, { flexDirection: "row", alignItems: "center", backgroundColor: colors.ultralight, borderTopRightRadius: 20, maxWidth: 200, marginLeft: 5, marginVertical: 5 }]}>
                            <Text style={{ fontFamily: global.FONT_REGULAR, fontSize: 15, color: colors.midnightBack }}>
                                (the answer to the Riddle is: "{ans}")
                            </Text>
                        </View>
                    )
                }
                <Text style={{ color: colors.alert, fontSize: 10, textAlign: 'right', fontFamily: global.FONT_REGULAR, fontWeight: 'bold', paddingLeft: 10 }}>{error}</Text>

            </View>
        )
    }
}



const mapStateToProps = ({ main }) => {
    return {
        daily_riddle: main.daily_riddle,
    }
}

const mapDispatch = (dispatch) => {
    return {
        getDailyRiddleQuestion: () => dispatch(getDailyRiddleQuestion()),
    }
}
export default connect(mapStateToProps, mapDispatch)(AudioMessage);